import React, { createContext, PropsWithChildren } from 'react';
import {
  experimentSegmentActive,
  getDynamicConfiguration,
  getStatsigClient,
  isFeatureEnabled,
  updateStatsigUser,
} from 'services/statsig/statsigManager';
import {
  DynamicConfigurationKey,
  ExperimentKey,
  FeatureFlagKey,
} from 'services/statsig/types';

export type StatsigContextProps = {
  updateUser: (userId: string, anonymousId: string) => Promise<void>;
  isFeatureEnabled: (key: FeatureFlagKey) => boolean;
  getDynamicConfiguration: (
    key: DynamicConfigurationKey,
  ) => Record<string, unknown>;
  experimentSegmentActive: (key: ExperimentKey, segment: string) => boolean;
};

export const StatsigContext = createContext<StatsigContextProps>(
  {} as StatsigContextProps,
);

// Functional statsig context that proxies to statsigManager
const statsigContextValue: StatsigContextProps = {
  updateUser: updateStatsigUser,
  isFeatureEnabled: (key: FeatureFlagKey) => isFeatureEnabled(key),
  getDynamicConfiguration: (key: DynamicConfigurationKey) =>
    getDynamicConfiguration(key),
  experimentSegmentActive: (key: ExperimentKey, segment: string) =>
    experimentSegmentActive(key, segment),
};

export const CrossPlatformStatsigProvider = ({
  children,
}: PropsWithChildren) => {
  // This provider proxies to statsigManager
  // Initialization happens in InitializationProvider.tsx (Phase 2)

  const client = getStatsigClient();

  if (!client) {
    // During initial load before initialization completes, return null
    // InitializationProvider will show loading screen
    return null;
  }

  return (
    <StatsigContext.Provider value={statsigContextValue}>
      {children}
    </StatsigContext.Provider>
  );
};
